// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2p25H","inner":"Form_inner__241yr","range":"Form_range__14ne3","name":"Form_name__y3XwH","actions":"Form_actions__1PAzw"};